import React, { useState, useEffect } from "react";
import { MessageCircle, X } from "lucide-react";
import { CONTACT } from "../mock";

const TextNowButton = () => {
  const [visible, setVisible] = useState(false);
  const [bubble, setBubble] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 1500);
    const t2 = setTimeout(() => setBubble(false), 9000);
    return () => {
      clearTimeout(t);
      clearTimeout(t2);
    };
  }, []);

  const message = encodeURIComponent(
    "Hi Hang Zen! I'd like to book a session — can you help?"
  );
  // sms: link with body works on iOS (?) and Android (?). Use both with a fallback.
  const smsHref = `sms:${CONTACT.phoneRaw};?&body=${message}`;

  if (!visible) return null;

  return (
    <div className="fixed bottom-20 right-5 z-[60] flex flex-col items-end gap-2 md:bottom-24">
      {bubble && (
        <div className="relative bg-white rounded-2xl shadow-2xl border border-slate-200 px-4 py-3 max-w-[240px] animate-in fade-in slide-in-from-bottom-2">
          <button
            onClick={() => setBubble(false)}
            className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-slate-800 hover:bg-slate-900 text-white flex items-center justify-center shadow-md"
            aria-label="Dismiss"
          >
            <X size={12} />
          </button>
          <div className="text-xs text-slate-500 font-semibold uppercase tracking-wider mb-0.5">
            Hang Zen
          </div>
          <div className="text-sm text-slate-800 font-medium leading-snug">
            Got a question? Text us now — we usually reply between sets 🤙
          </div>
          <div className="absolute -bottom-1.5 right-7 w-3 h-3 bg-white border-r border-b border-slate-200 rotate-45" />
        </div>
      )}

      <a
        href={smsHref}
        className="group relative inline-flex items-center gap-2 pl-3 pr-5 py-3 bg-[#0b3a5f] hover:bg-[#0e4a78] text-white font-bold rounded-full shadow-2xl ring-4 ring-[#0b3a5f]/20 transition-all hover:scale-105"
        style={{ animation: "pulse-ring-blue 2.4s ease-in-out infinite" }}
        aria-label="Text us now"
        onClick={() => setBubble(false)}
      >
        <span className="relative w-9 h-9 rounded-full bg-white/15 flex items-center justify-center">
          <MessageCircle size={20} strokeWidth={2.5} />
          <span className="absolute top-0 right-0 w-2.5 h-2.5 rounded-full bg-emerald-400 ring-2 ring-[#0b3a5f] animate-pulse" />
        </span>
        <span className="text-sm tracking-wide">Text Now</span>
      </a>
    </div>
  );
};

export default TextNowButton;
